var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "inside" } },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12 mb-2 pl-1" }, [
              _c(
                "button",
                {
                  staticClass:
                    "justify-content-left text-decoration-none btn-link flex-row d-flex align-items-center pr-2 pb-2 text-primary",
                  on: {
                    click: function ($event) {
                      return _vm.home()
                    },
                  },
                },
                [
                  _c("i", {
                    staticClass: "fa fa-chevron-left fa-fw pull-left text-info",
                  }),
                  _vm._v(" Voltar "),
                ]
              ),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "container" }, [
          _vm.billsInfo && !_vm.loadBoletos
            ? _c(
                "div",
                { staticClass: "row" },
                [_vm._m(0), _c("HeaderOptions")],
                1
              )
            : _vm._e(),
        ]),
      ]),
      _c("ProgressLoading", { attrs: { loading: _vm.loadBoletos } }),
      _vm.pixInfo
        ? _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-inline-flex flex-wrap flex-column col-acao mt-0 pt-0 col-lg-9",
                },
                [
                  _c("div", { staticClass: "card m-1" }, [
                    _c("div", { staticClass: "card-body px-4" }, [
                      _c("div", { staticClass: "row" }, [
                        _c("div", { staticClass: "col-lg-12 col-12" }, [
                          _c(
                            "div",
                            {
                              class: [_vm.largura < 500 ? "" : "flex-card m-5"],
                            },
                            [
                              _c(
                                "div",
                                {
                                  class: [
                                    _vm.largura < 500
                                      ? "col-xs-8 col-12 d-flex flex-column col-lg-5 pb-3 pt-2 flex-align-center"
                                      : "",
                                  ],
                                },
                                [
                                  _c("qrcode-vue", {
                                    attrs: {
                                      value: _vm.pixInfo.pixCopyPaste,
                                      size: 150,
                                      level: "H",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._m(1),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                color: "red",
                                "font-size": "12px",
                              },
                            },
                            [
                              _vm._v(
                                " ATENÇÃO! Evite fraudes: Antes de efetuar o PIX para pagamento do seu acordo PORTOBANK, verifique o NOME do beneficiário e CNPJ. "
                              ),
                            ]
                          ),
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-xs-8 col-12 col-lg-12 px-1 mt-4",
                            },
                            [
                              _c("p", { staticClass: "text-info mb-1" }, [
                                _vm._v(" Código de pagamento PIX:"),
                                _vm.pixInfo.pixCopyPaste
                                  ? _c(
                                      "a",
                                      {
                                        staticClass:
                                          "btn btn-link btn-sm float-right pl-1 pr-3",
                                        staticStyle: { cursor: "pointer" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.copiarLinhaDigitavel(
                                              _vm.pixInfo.pixCopyPaste
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("Copiar")]
                                    )
                                  : _vm._e(),
                              ]),
                              _c(
                                "p",
                                {
                                  staticClass: "codebar",
                                  on: { click: _vm.copyCodePix },
                                },
                                [
                                  _vm._v(
                                    " " + _vm._s(_vm.pixInfo.pixCopyPaste) + " "
                                  ),
                                ]
                              ),
                            ]
                          ),
                          _c("div", [
                            _c(
                              "button",
                              {
                                staticClass: "btn mr-1 mb-1 btn-link text-left",
                                on: {
                                  click: function ($event) {
                                    return _vm.getBillInfo()
                                  },
                                },
                              },
                              [_vm._v(" Exibir boletos ")]
                            ),
                          ]),
                        ]),
                      ]),
                    ]),
                  ]),
                ]
              ),
            ]),
          ])
        : _vm._e(),
      !_vm.billsInfo && !_vm.loadBoletos && !_vm.pixInfo
        ? _c("div", { staticClass: "container" }, [
            _c(
              "h4",
              {
                staticClass:
                  "mb-1 text-danger d-flex flex-row align-items-center",
              },
              [
                _vm._v(
                  " Não foi possível apresentar dados da emissão de fatura. "
                ),
              ]
            ),
          ])
        : _vm._e(),
      _vm.billsInfo &&
      !_vm.loadBoletos &&
      !_vm.fromEmitirFatura &&
      !_vm.fromProposals
        ? _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "card m-1" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-12 col-12" }, [
                        !_vm.loading && _vm.paidInstallments.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "d-flex",
                                staticStyle: {
                                  "justify-content": "space-between",
                                },
                              },
                              [
                                _c("h5", { staticClass: "text-bold mt-2" }, [
                                  _vm._v("Parcelas pagas"),
                                ]),
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link dropdown-toggle",
                                    attrs: {
                                      href: "#boleto",
                                      id: "userDropdown",
                                      role: "button",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "dropdownOpen",
                                    },
                                    on: {
                                      click: _vm.toggleDropdownPaidInstallments,
                                    },
                                  },
                                  [
                                    !_vm.dropdownOpenPaidInstallments
                                      ? _c("i", {
                                          staticClass: "fa fa-angle-down fa-lg",
                                        })
                                      : _vm._e(),
                                    _vm.dropdownOpenPaidInstallments
                                      ? _c("i", {
                                          staticClass: "fa fa-angle-up fa-lg",
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c("hr", { staticStyle: { "margin-top": "0" } }),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.dropdownOpenPaidInstallments,
                                expression: "dropdownOpenPaidInstallments",
                              },
                            ],
                            staticClass: "accordion mb-4",
                            attrs: { id: "boleto" },
                          },
                          _vm._l(
                            _vm.paidInstallments,
                            function (installment, key, index) {
                              return _c(
                                "div",
                                {
                                  key: `${key}-${index}`,
                                  staticClass: "card m-0 px-0 py-0",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card-header mb-2",
                                      staticStyle: {
                                        "background-color": "#f5f5f5",
                                        "border-radius": "5px",
                                      },
                                      attrs: { id: "head2" },
                                    },
                                    [
                                      _c("div", { staticClass: "row p-3" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Parcela")]
                                            ),
                                            _vm.isEmitirFatura
                                              ? _c(
                                                  "h6",
                                                  { staticClass: "text-body" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          key +
                                                            1 +
                                                            "/" +
                                                            (key + 1)
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.isFromProposals
                                              ? _c(
                                                  "h6",
                                                  { staticClass: "text-body" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          installment.installmentNumber +
                                                            "/" +
                                                            String(
                                                              _vm.billsInfo
                                                                .installmentNumber
                                                            )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.isFromAgreements
                                              ? _c(
                                                  "h6",
                                                  { staticClass: "text-body" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          parseInt(
                                                            installment.installmentNumber
                                                          ) +
                                                            1 +
                                                            "/" +
                                                            String(
                                                              _vm.agreementInfo
                                                                .installmentNumber
                                                            )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Valor")]
                                            ),
                                            _c(
                                              "h6",
                                              { staticClass: "text-body" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatFloatToReal(
                                                        parseFloat(
                                                          installment.paymentValue,
                                                          10
                                                        )
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Vencimento")]
                                            ),
                                            _c("h6", {}, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatData(
                                                      installment.dueDate,
                                                      "YYYY-MM-DD",
                                                      "L"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Status")]
                                            ),
                                            installment.status === "EmAberto"
                                              ? _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "status-badge-open",
                                                  },
                                                  [_vm._v(" Em aberto ")]
                                                )
                                              : _vm._e(),
                                            installment.status === "Liquidada"
                                              ? _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "status-badge-paid",
                                                  },
                                                  [_vm._v(" Pago ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                        _vm.currentInstallment &&
                        _vm.currentInstallment.pixCopyPaste
                          ? _c("div", { staticClass: "accordion mb-2" }, [
                              _vm._m(2),
                              _c(
                                "div",
                                {
                                  staticClass: "container mt-4",
                                  staticStyle: {
                                    "background-color": "rgb(245, 245, 245)",
                                    "border-radius": "5px",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card-header mb-2",
                                      staticStyle: {
                                        "background-color": "#f5f5f5",
                                        "border-radius": "5px",
                                      },
                                      attrs: { id: "head1" },
                                    },
                                    [
                                      _c("div", { staticClass: "row mt-2" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Parcela")]
                                            ),
                                            _c(
                                              "h6",
                                              { staticClass: "text-body" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      parseInt(
                                                        _vm.currentInstallment
                                                          .installmentNumber
                                                      ) +
                                                        1 +
                                                        "/" +
                                                        String(
                                                          _vm.agreementInfo
                                                            .installmentNumber
                                                        )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Valor")]
                                            ),
                                            _c(
                                              "h6",
                                              { staticClass: "text-body" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatFloatToReal(
                                                        parseFloat(
                                                          _vm.currentInstallment
                                                            .paymentValue,
                                                          10
                                                        )
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Vencimento")]
                                            ),
                                            _c(
                                              "h6",
                                              {
                                                staticStyle: { color: "black" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatData(
                                                        _vm.currentInstallment
                                                          .dueDate,
                                                        "YYYY-MM-DD",
                                                        "L"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Status")]
                                            ),
                                            _vm.currentInstallment.status ===
                                            "EmAberto"
                                              ? _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "status-badge-open",
                                                  },
                                                  [_vm._v(" Em aberto ")]
                                                )
                                              : _vm._e(),
                                            _vm.currentInstallment.status ===
                                            "Liquidada"
                                              ? _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "status-badge-paid",
                                                  },
                                                  [_vm._v(" Pago ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                  _c("hr", {
                                    staticStyle: {
                                      "border-top": "1px solid #151515",
                                    },
                                  }),
                                  _c("div", { attrs: { id: "divPix" } }, [
                                    _vm._m(3),
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          _vm.largura < 500
                                            ? ""
                                            : "flex-card m-5",
                                        ],
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            class: [
                                              _vm.largura < 500
                                                ? "col-xs-8 col-12 d-flex flex-column col-lg-5 pb-3 pt-2 flex-align-center"
                                                : "",
                                            ],
                                          },
                                          [
                                            _c("qrcode-vue", {
                                              staticStyle: {
                                                "background-color": "#fff",
                                                padding: "10px",
                                              },
                                              attrs: {
                                                value:
                                                  _vm.currentInstallment
                                                    .pixCopyPaste,
                                                size: 150,
                                                level: "H",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("div", { staticClass: "my-auto" }, [
                                          _vm.largura > 500
                                            ? _c(
                                                "p",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    " Acesse seu App de pagamentos e faça a leitura do QR Code ao lado para efetuar o pagamento de forma segura e rápida. "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.largura < 500
                                            ? _c(
                                                "p",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    " Acesse seu App de pagamentos e faça a leitura do QR Code acima para efetuar o pagamento de forma segura e rápida. "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          color: "red",
                                          "font-size": "12px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " ATENÇÃO! Evite fraudes: Antes de efetuar o PIX para pagamento do seu acordo PORTOBANK, verifique o NOME do beneficiário e CNPJ. "
                                        ),
                                      ]
                                    ),
                                    _vm._m(4),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-8 col-12 col-lg-12 px-1 mt-2",
                                        staticStyle: {
                                          "background-color": "#d9d9d9",
                                          "border-radius": "5px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "d-flex",
                                            staticStyle: {
                                              "align-items": "center",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copiarCodigoPix(
                                                  _vm.currentInstallment
                                                    .pixCopyPaste
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "codebar text-start",
                                                staticStyle: {
                                                  "background-color": "#d9d9d9",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.currentInstallment
                                                        .pixCopyPaste
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "fa fa-clone mr-2",
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text-center",
                                        on: {
                                          click: function ($event) {
                                            return _vm.copiarCodigoPix(
                                              _vm.currentInstallment
                                                .pixCopyPaste
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "black",
                                              cursor: "pointer",
                                            },
                                          },
                                          [_vm._v("Clique para copiar")]
                                        ),
                                      ]
                                    ),
                                    !_vm.boletoGerado
                                      ? _c("div", [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary mr-2 mb-4 p-2",
                                              staticStyle: {
                                                width: "100%",
                                                "border-radius": "20px",
                                              },
                                              attrs: {
                                                disabled: _vm.loadingBoleto,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getBillInfo()
                                                },
                                              },
                                            },
                                            [_vm._v(" GERAR BOLETO ")]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ]),
                                  _vm.loadingBoleto &&
                                  _vm.contentInstallment ===
                                    _vm.currentInstallment
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "col-xs-8 col-12 d-flex flex-column col-lg-12 pb-3 pt-2",
                                        },
                                        [
                                          _c("ProgressLoading", {
                                            attrs: {
                                              loading: _vm.loadingBoleto,
                                            },
                                          }),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.contentInstallment.digitableLine
                                    ? _c(
                                        "div",
                                        {
                                          class: [
                                            _vm.contentInstallment.digitableLine
                                              ? "collapse show"
                                              : "collapse",
                                          ],
                                          attrs: {
                                            "aria-labelledby": "heading1",
                                          },
                                        },
                                        [
                                          _vm.pix
                                            ? _c(
                                                "h6",
                                                {
                                                  staticClass:
                                                    "border-bottom pb-3 mb-0",
                                                },
                                                [_vm._v(" Boleto ")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "div",
                                            { staticClass: "card-body px-4" },
                                            [
                                              _vm.contentInstallment
                                                .digitableLine ||
                                              _vm.contentInstallment.status !==
                                                "Liquidada"
                                                ? _c(
                                                    "div",
                                                    { staticClass: "row" },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-xs-8 col-12 col-lg-12 px-1",
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "text-info mb-1",
                                                            },
                                                            [
                                                              _vm._v(
                                                                "Linha digitável:"
                                                              ),
                                                            ]
                                                          ),
                                                          _vm.contentInstallment
                                                            .digitableLine
                                                            ? _c(
                                                                "a",
                                                                {
                                                                  staticClass:
                                                                    "text-primary btn-link btn-sm float-right mt-2 pl-1 pr-3",
                                                                  staticStyle: {
                                                                    cursor:
                                                                      "pointer",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.copiarLinhaDigitavel(
                                                                          _vm
                                                                            .contentInstallment
                                                                            .digitableLine
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Copiar"
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "codebar",
                                                              staticStyle: {
                                                                "background-color":
                                                                  "rgb(217, 217, 217)",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    _vm
                                                                      .contentInstallment
                                                                      .digitableLine
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-12 d-flex col-lg-12 flex-row px-0 mt-2 justify-content-around",
                                                        },
                                                        [
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "text-primary btn-link mr-1 mb-1 text-left",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.loadingDownloadEmitirFatura ||
                                                                  _vm.loading,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.downloadBoleto(
                                                                      _vm.contentInstallment
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-download fa-fw pull-left pt-1 pb-2 d-none d-sm-block",
                                                              }),
                                                              _vm._v(
                                                                " Baixar boleto "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "text-primary mr-1 mb-1 btn-link text-left",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.loadingDownloadEmitirFatura ||
                                                                  _vm.loading ||
                                                                  (!_vm.user
                                                                    .PhoneNumber &&
                                                                    !_vm.user
                                                                      .MobileNumber),
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.sendSms(
                                                                      _vm
                                                                        .contentInstallment
                                                                        .digitableLine
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-mobile fa-fw fa-lg pull-left mr-1 pt-1 pb-2 d-none d-sm-block",
                                                              }),
                                                              _vm._v(
                                                                "Receber por SMS "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "button",
                                                            {
                                                              staticClass:
                                                                "text-primary mr-1 mb-1 btn-link text-left",
                                                              attrs: {
                                                                disabled:
                                                                  _vm.loadingDownloadEmitirFatura ||
                                                                  _vm.loading ||
                                                                  !_vm.user
                                                                    .Email,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.sendEmail(
                                                                      _vm
                                                                        .contentInstallment
                                                                        .digitableLine
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _c("i", {
                                                                staticClass:
                                                                  "fa fa-envelope-o fa-fw pull-left pt-1 pb-2 d-none d-sm-block",
                                                              }),
                                                              _vm._v(
                                                                "Receber por e-mail "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                      _vm.loading
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-xs-8 col-12 d-flex flex-column col-lg-12 pb-3 pt-2",
                                                            },
                                                            [
                                                              _c(
                                                                "ProgressLoading",
                                                                {
                                                                  attrs: {
                                                                    loading:
                                                                      _vm.loading,
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                      _vm.loadingDownloadEmitirFatura
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "col-xs-8 col-12 d-flex flex-column col-lg-12 pb-3 pt-2",
                                                            },
                                                            [
                                                              _c(
                                                                "ProgressLoading",
                                                                {
                                                                  attrs: {
                                                                    loading:
                                                                      _vm.loadingDownloadEmitirFatura,
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                            ])
                          : _vm._e(),
                        _vm.contentInstallment.digitableLine &&
                        !_vm.currentInstallment.pixCopyPaste
                          ? _c(
                              "div",
                              {
                                class: [
                                  _vm.contentInstallment.digitableLine
                                    ? "collapse show"
                                    : "collapse",
                                ],
                                attrs: { "aria-labelledby": "heading1" },
                              },
                              [
                                _c(
                                  "h6",
                                  { staticClass: "border-bottom pb-3 mb-0" },
                                  [_vm._v(" Boleto ")]
                                ),
                                _c("div", { staticClass: "card-body px-4" }, [
                                  _vm.contentInstallment.digitableLine ||
                                  _vm.contentInstallment.status !== "Liquidada"
                                    ? _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-xs-8 col-12 col-lg-12 px-1",
                                          },
                                          [
                                            _c(
                                              "p",
                                              { staticClass: "text-info mb-1" },
                                              [_vm._v("Linha digitável:")]
                                            ),
                                            _vm.contentInstallment.digitableLine
                                              ? _c(
                                                  "a",
                                                  {
                                                    staticClass:
                                                      "text-primary btn-link btn-sm float-right mt-2 pl-1 pr-3",
                                                    staticStyle: {
                                                      cursor: "pointer",
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.copiarLinhaDigitavel(
                                                          _vm.contentInstallment
                                                            .digitableLine
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("Copiar")]
                                                )
                                              : _vm._e(),
                                            _c(
                                              "p",
                                              {
                                                staticClass: "codebar",
                                                staticStyle: {
                                                  "background-color":
                                                    "rgb(217, 217, 217)",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.contentInstallment
                                                        .digitableLine
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-12 d-flex col-lg-12 flex-row px-0 mt-2 justify-content-around",
                                          },
                                          [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "text-primary btn-link mr-1 mb-1 text-left",
                                                attrs: {
                                                  disabled:
                                                    _vm.loadingDownloadEmitirFatura ||
                                                    _vm.loading,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.downloadBoleto(
                                                      _vm.contentInstallment
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-download fa-fw pull-left pt-1 pb-2 d-none d-sm-block",
                                                }),
                                                _vm._v(" Baixar boleto "),
                                              ]
                                            ),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "text-primary mr-1 mb-1 btn-link text-left",
                                                attrs: {
                                                  disabled:
                                                    _vm.loadingDownloadEmitirFatura ||
                                                    _vm.loading ||
                                                    (!_vm.user.PhoneNumber &&
                                                      !_vm.user.MobileNumber),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.sendSms(
                                                      _vm.contentInstallment
                                                        .digitableLine
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-mobile fa-fw fa-lg pull-left mr-1 pt-1 pb-2 d-none d-sm-block",
                                                }),
                                                _vm._v("Receber por SMS "),
                                              ]
                                            ),
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "text-primary mr-1 mb-1 btn-link text-left",
                                                attrs: {
                                                  disabled:
                                                    _vm.loadingDownloadEmitirFatura ||
                                                    _vm.loading ||
                                                    !_vm.user.Email,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.sendEmail(
                                                      _vm.contentInstallment
                                                        .digitableLine
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-envelope-o fa-fw pull-left pt-1 pb-2 d-none d-sm-block",
                                                }),
                                                _vm._v("Receber por e-mail "),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _vm.loading
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-xs-8 col-12 d-flex flex-column col-lg-12 pb-3 pt-2",
                                              },
                                              [
                                                _c("ProgressLoading", {
                                                  attrs: {
                                                    loading: _vm.loading,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                        _vm.loadingDownloadEmitirFatura
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-xs-8 col-12 d-flex flex-column col-lg-12 pb-3 pt-2",
                                              },
                                              [
                                                _c("ProgressLoading", {
                                                  attrs: {
                                                    loading:
                                                      _vm.loadingDownloadEmitirFatura,
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ])
                                    : _vm._e(),
                                ]),
                              ]
                            )
                          : _vm._e(),
                        _c("hr"),
                        !_vm.loading && _vm.openInstallments.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "d-flex",
                                staticStyle: {
                                  "justify-content": "space-between",
                                  "align-items": "baseline",
                                },
                              },
                              [
                                _c("h5", { staticClass: "text-bold mt-2" }, [
                                  _vm._v("Mais parcelas em aberto"),
                                ]),
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link dropdown-toggle",
                                    attrs: {
                                      href: "#openParcels",
                                      id: "userDropdownOpen",
                                      role: "button",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "dropdownOpen",
                                    },
                                    on: {
                                      click: _vm.toggleDropdownOpenInstallments,
                                    },
                                  },
                                  [
                                    !_vm.dropdownOpenInstallments
                                      ? _c("i", {
                                          staticClass: "fa fa-angle-down fa-lg",
                                        })
                                      : _vm._e(),
                                    _vm.dropdownOpenInstallments
                                      ? _c("i", {
                                          staticClass: "fa fa-angle-up fa-lg",
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.dropdownOpenInstallments,
                                expression: "dropdownOpenInstallments",
                              },
                            ],
                            staticClass: "accordion",
                          },
                          _vm._l(
                            _vm.openInstallments,
                            function (openInstallment, key1, index1) {
                              return _c(
                                "div",
                                {
                                  key: `${key1}-${index1}`,
                                  staticClass: "card m-0 px-0 py-0 mb-2",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card-header",
                                      staticStyle: {
                                        "background-color": "#f5f5f5",
                                        "border-radius": "5px",
                                      },
                                      attrs: { id: "head3" },
                                    },
                                    [
                                      _c("div", { staticClass: "row p-3" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Parcela")]
                                            ),
                                            _vm.isEmitirFatura
                                              ? _c(
                                                  "h6",
                                                  { staticClass: "text-body" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          key1 +
                                                            1 +
                                                            "/" +
                                                            (key1 + 1)
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.isFromProposals
                                              ? _c(
                                                  "h6",
                                                  { staticClass: "text-body" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          openInstallment.installmentNumber +
                                                            "/" +
                                                            String(
                                                              _vm.billsInfo
                                                                .installmentNumber
                                                            )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.isFromAgreements
                                              ? _c(
                                                  "h6",
                                                  { staticClass: "text-body" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          parseInt(
                                                            openInstallment.installmentNumber
                                                          ) +
                                                            1 +
                                                            "/" +
                                                            String(
                                                              _vm.agreementInfo
                                                                .installmentNumber
                                                            )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Valor")]
                                            ),
                                            _c(
                                              "h6",
                                              { staticClass: "text-body" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatFloatToReal(
                                                        parseFloat(
                                                          openInstallment.paymentValue,
                                                          10
                                                        )
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Vencimento")]
                                            ),
                                            _c("h6", {}, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatData(
                                                      openInstallment.dueDate,
                                                      "YYYY-MM-DD",
                                                      "L"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Status")]
                                            ),
                                            openInstallment.status ===
                                            "EmAberto"
                                              ? _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "status-badge-open",
                                                  },
                                                  [_vm._v(" Em aberto ")]
                                                )
                                              : _vm._e(),
                                            openInstallment.status ===
                                            "Liquidada"
                                              ? _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "status-badge-paid",
                                                  },
                                                  [_vm._v(" Pago ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.billsInfo && !_vm.loadBoletos && _vm.fromProposals
        ? _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "card m-1" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-12 col-12" }, [
                        !_vm.loading && _vm.paidInstallments.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "d-flex",
                                staticStyle: {
                                  "justify-content": "space-between",
                                },
                              },
                              [
                                _c("h5", { staticClass: "text-bold mt-2" }, [
                                  _vm._v("Parcelas pagas"),
                                ]),
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link dropdown-toggle",
                                    attrs: {
                                      href: "#boleto",
                                      id: "userDropdown",
                                      role: "button",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "dropdownOpen",
                                    },
                                    on: {
                                      click: _vm.toggleDropdownPaidInstallments,
                                    },
                                  },
                                  [
                                    !_vm.dropdownOpenPaidInstallments
                                      ? _c("i", {
                                          staticClass: "fa fa-angle-down fa-lg",
                                        })
                                      : _vm._e(),
                                    _vm.dropdownOpenPaidInstallments
                                      ? _c("i", {
                                          staticClass: "fa fa-angle-up fa-lg",
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm.paidInstallments.length > 0
                          ? _c("hr", { staticStyle: { "margin-top": "0" } })
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.dropdownOpenPaidInstallments,
                                expression: "dropdownOpenPaidInstallments",
                              },
                            ],
                            staticClass: "accordion mb-4",
                            attrs: { id: "boleto" },
                          },
                          _vm._l(
                            _vm.paidInstallments,
                            function (installment, key, index) {
                              return _c(
                                "div",
                                {
                                  key: `${key}-${index}`,
                                  staticClass: "card m-0 px-0 py-0",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card-header mb-2",
                                      staticStyle: {
                                        "background-color": "#f5f5f5",
                                        "border-radius": "5px",
                                      },
                                      attrs: { id: "head2" },
                                    },
                                    [
                                      _c("div", { staticClass: "row p-3" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Parcela")]
                                            ),
                                            _c(
                                              "h6",
                                              { staticClass: "text-body" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      installment.installmentNumber +
                                                        "/" +
                                                        String(
                                                          _vm.billsInfo
                                                            .installmentNumber
                                                        )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Valor")]
                                            ),
                                            _c(
                                              "h6",
                                              { staticClass: "text-body" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatFloatToReal(
                                                        parseFloat(
                                                          installment.paymentValue,
                                                          10
                                                        )
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Vencimento")]
                                            ),
                                            _c("h6", {}, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatData(
                                                      installment.dueDate,
                                                      "YYYY-MM-DD",
                                                      "L"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Status")]
                                            ),
                                            installment.status === "EmAberto"
                                              ? _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "status-badge-open",
                                                  },
                                                  [_vm._v(" Em aberto ")]
                                                )
                                              : _vm._e(),
                                            installment.status === "Liquidada"
                                              ? _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "status-badge-paid",
                                                  },
                                                  [_vm._v(" Pago ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                        _c("div", { staticClass: "accordion mb-2" }, [
                          _vm._m(5),
                          _c(
                            "div",
                            {
                              staticClass: "container mt-4",
                              staticStyle: {
                                "background-color": "rgb(245, 245, 245)",
                                "border-radius": "5px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "card-header mb-2",
                                  staticStyle: {
                                    "background-color": "#f5f5f5",
                                    "border-radius": "5px",
                                  },
                                  attrs: { id: "head1" },
                                },
                                [
                                  _c("div", { staticClass: "row mt-2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex col-lg-12 col-12",
                                        staticStyle: {
                                          "justify-content": "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-1",
                                            staticStyle: { color: "black" },
                                          },
                                          [_vm._v("Parcela")]
                                        ),
                                        _c("h6", { staticClass: "text-body" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                parseInt(
                                                  _vm.currentInstallment
                                                    .installmentNumber
                                                ) +
                                                  "/" +
                                                  String(
                                                    _vm.agreementInfo
                                                      .installmentNumber
                                                  )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex col-lg-12 col-12",
                                        staticStyle: {
                                          "justify-content": "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-1",
                                            staticStyle: { color: "black" },
                                          },
                                          [_vm._v("Valor")]
                                        ),
                                        _c("h6", { staticClass: "text-body" }, [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.formatFloatToReal(
                                                  parseFloat(
                                                    _vm.currentInstallment
                                                      .paymentValue,
                                                    10
                                                  )
                                                )
                                              ) +
                                              " "
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex col-lg-12 col-12",
                                        staticStyle: {
                                          "justify-content": "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-1",
                                            staticStyle: { color: "black" },
                                          },
                                          [_vm._v("Vencimento")]
                                        ),
                                        _c(
                                          "h6",
                                          { staticStyle: { color: "black" } },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatData(
                                                    _vm.currentInstallment
                                                      .dueDate,
                                                    "YYYY-MM-DD",
                                                    "L"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex col-lg-12 col-12",
                                        staticStyle: {
                                          "justify-content": "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-1",
                                            staticStyle: { color: "black" },
                                          },
                                          [_vm._v("Status")]
                                        ),
                                        _vm.currentInstallment.status ===
                                        "EmAberto"
                                          ? _c(
                                              "h6",
                                              {
                                                staticClass:
                                                  "status-badge-open",
                                              },
                                              [_vm._v(" Em aberto ")]
                                            )
                                          : _vm._e(),
                                        _vm.currentInstallment.status ===
                                        "Liquidada"
                                          ? _c(
                                              "h6",
                                              {
                                                staticClass:
                                                  "status-badge-paid",
                                              },
                                              [_vm._v(" Pago ")]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _vm.currentInstallment.pixCopyPaste
                                ? _c("div", { attrs: { id: "divPix" } }, [
                                    _vm._m(6),
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          _vm.largura < 500
                                            ? ""
                                            : "flex-card m-5",
                                        ],
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            class: [
                                              _vm.largura < 500
                                                ? "col-xs-8 col-12 d-flex flex-column col-lg-5 pb-3 pt-2 flex-align-center"
                                                : "",
                                            ],
                                          },
                                          [
                                            _c("qrcode-vue", {
                                              staticStyle: {
                                                "background-color": "#fff",
                                                padding: "10px",
                                              },
                                              attrs: {
                                                value:
                                                  _vm.currentInstallment
                                                    .pixCopyPaste,
                                                size: 150,
                                                level: "H",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("div", { staticClass: "my-auto" }, [
                                          _vm.largura > 500
                                            ? _c(
                                                "p",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    " Acesse seu App de pagamentos e faça a leitura do QR Code ao lado para efetuar o pagamento de forma segura e rápida. "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.largura < 500
                                            ? _c(
                                                "p",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    " Acesse seu App de pagamentos e faça a leitura do QR Code acima para efetuar o pagamento de forma segura e rápida. "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          color: "red",
                                          "font-size": "12px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " ATENÇÃO! Evite fraudes: Antes de efetuar o PIX para pagamento do seu acordo PORTOBANK, verifique o NOME do beneficiário e CNPJ. "
                                        ),
                                      ]
                                    ),
                                    _vm._m(7),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-8 col-12 col-lg-12 px-1 mt-2",
                                        staticStyle: {
                                          "background-color": "#d9d9d9",
                                          "border-radius": "5px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "d-flex",
                                            staticStyle: {
                                              "align-items": "center",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copiarCodigoPix(
                                                  _vm.currentInstallment
                                                    .pixCopyPaste
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "codebar text-start",
                                                staticStyle: {
                                                  "background-color": "#d9d9d9",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.currentInstallment
                                                        .pixCopyPaste
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "fa fa-clone mr-2",
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text-center",
                                        on: {
                                          click: function ($event) {
                                            return _vm.copiarCodigoPix(
                                              _vm.currentInstallment
                                                .pixCopyPaste
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "black",
                                              cursor: "pointer",
                                            },
                                          },
                                          [_vm._v("Clique para copiar")]
                                        ),
                                      ]
                                    ),
                                    !_vm.boletoGerado
                                      ? _c("div", [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "btn btn-primary mr-2 mb-4 p-2",
                                              staticStyle: {
                                                width: "100%",
                                                "border-radius": "20px",
                                              },
                                              attrs: {
                                                disabled: _vm.loadingBoleto,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getBillInfo()
                                                },
                                              },
                                            },
                                            [_vm._v(" GERAR BOLETO ")]
                                          ),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                              _vm.loadingBoleto &&
                              _vm.contentInstallment === _vm.currentInstallment
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-xs-8 col-12 d-flex flex-column col-lg-12 pb-3 pt-2",
                                    },
                                    [
                                      _c("ProgressLoading", {
                                        attrs: { loading: _vm.loadingBoleto },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.contentInstallment.digitableLine
                                ? _c(
                                    "div",
                                    {
                                      class: [
                                        _vm.contentInstallment.digitableLine
                                          ? "collapse show"
                                          : "collapse",
                                      ],
                                      attrs: { "aria-labelledby": "heading1" },
                                    },
                                    [
                                      _c(
                                        "h6",
                                        {
                                          staticClass:
                                            "border-bottom pb-3 mb-0",
                                        },
                                        [_vm._v(" Boleto ")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "card-body px-4" },
                                        [
                                          _vm.contentInstallment
                                            .digitableLine ||
                                          _vm.contentInstallment.status !==
                                            "Liquidada"
                                            ? _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-8 col-12 col-lg-12 px-1",
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-info mb-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Linha digitável:"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm.contentInstallment
                                                        .digitableLine
                                                        ? _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "text-primary btn-link btn-sm float-right mt-2 pl-1 pr-3",
                                                              staticStyle: {
                                                                cursor:
                                                                  "pointer",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.copiarLinhaDigitavel(
                                                                      _vm
                                                                        .contentInstallment
                                                                        .digitableLine
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("Copiar")]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "codebar",
                                                          staticStyle: {
                                                            "background-color":
                                                              "rgb(217, 217, 217)",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm
                                                                  .contentInstallment
                                                                  .digitableLine
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-12 d-flex col-lg-12 flex-row px-0 mt-2 justify-content-around",
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "text-primary btn-link mr-1 mb-1 text-left",
                                                          attrs: {
                                                            disabled:
                                                              _vm.loadingDownloadEmitirFatura ||
                                                              _vm.loading,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.downloadBoleto(
                                                                _vm.contentInstallment
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-download fa-fw pull-left pt-1 pb-2 d-none d-sm-block",
                                                          }),
                                                          _vm._v(
                                                            " Baixar boleto "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "text-primary mr-1 mb-1 btn-link text-left",
                                                          attrs: {
                                                            disabled:
                                                              _vm.loadingDownloadEmitirFatura ||
                                                              _vm.loading ||
                                                              (!_vm.user
                                                                .PhoneNumber &&
                                                                !_vm.user
                                                                  .MobileNumber),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.sendSms(
                                                                _vm
                                                                  .contentInstallment
                                                                  .digitableLine
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-mobile fa-fw fa-lg pull-left mr-1 pt-1 pb-2 d-none d-sm-block",
                                                          }),
                                                          _vm._v(
                                                            "Receber por SMS "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "text-primary mr-1 mb-1 btn-link text-left",
                                                          attrs: {
                                                            disabled:
                                                              _vm.loadingDownloadEmitirFatura ||
                                                              _vm.loading ||
                                                              !_vm.user.Email,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.sendEmail(
                                                                _vm
                                                                  .contentInstallment
                                                                  .digitableLine
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-envelope-o fa-fw pull-left pt-1 pb-2 d-none d-sm-block",
                                                          }),
                                                          _vm._v(
                                                            "Receber por e-mail "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.loading
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-xs-8 col-12 d-flex flex-column col-lg-12 pb-3 pt-2",
                                                        },
                                                        [
                                                          _c(
                                                            "ProgressLoading",
                                                            {
                                                              attrs: {
                                                                loading:
                                                                  _vm.loading,
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm.loadingDownloadEmitirFatura
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-xs-8 col-12 d-flex flex-column col-lg-12 pb-3 pt-2",
                                                        },
                                                        [
                                                          _c(
                                                            "ProgressLoading",
                                                            {
                                                              attrs: {
                                                                loading:
                                                                  _vm.loadingDownloadEmitirFatura,
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _c("hr"),
                        !_vm.loading && _vm.openInstallments.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "d-flex",
                                staticStyle: {
                                  "justify-content": "space-between",
                                  "align-items": "baseline",
                                },
                              },
                              [
                                _c("h5", { staticClass: "text-bold mt-2" }, [
                                  _vm._v("Mais parcelas em aberto"),
                                ]),
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link dropdown-toggle",
                                    attrs: {
                                      href: "#openParcels",
                                      id: "userDropdownOpen",
                                      role: "button",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "dropdownOpen",
                                    },
                                    on: {
                                      click: _vm.toggleDropdownOpenInstallments,
                                    },
                                  },
                                  [
                                    !_vm.dropdownOpenInstallments
                                      ? _c("i", {
                                          staticClass: "fa fa-angle-down fa-lg",
                                        })
                                      : _vm._e(),
                                    _vm.dropdownOpenInstallments
                                      ? _c("i", {
                                          staticClass: "fa fa-angle-up fa-lg",
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.dropdownOpenInstallments,
                                expression: "dropdownOpenInstallments",
                              },
                            ],
                            staticClass: "accordion",
                          },
                          _vm._l(
                            _vm.openInstallments,
                            function (openInstallment, key1, index1) {
                              return _c(
                                "div",
                                {
                                  key: `${key1}-${index1}`,
                                  staticClass: "card m-0 px-0 py-0 mb-2",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card-header",
                                      staticStyle: {
                                        "background-color": "#f5f5f5",
                                        "border-radius": "5px",
                                      },
                                      attrs: { id: "head3" },
                                    },
                                    [
                                      _c("div", { staticClass: "row p-3" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Parcela")]
                                            ),
                                            _c(
                                              "h6",
                                              { staticClass: "text-body" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      openInstallment.installmentNumber +
                                                        "/" +
                                                        String(
                                                          _vm.billsInfo
                                                            .installmentNumber
                                                        )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Valor")]
                                            ),
                                            _c(
                                              "h6",
                                              { staticClass: "text-body" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatFloatToReal(
                                                        parseFloat(
                                                          openInstallment.paymentValue,
                                                          10
                                                        )
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Vencimento")]
                                            ),
                                            _c(
                                              "h6",
                                              {
                                                staticStyle: { color: "black" },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatData(
                                                        openInstallment.dueDate,
                                                        "YYYY-MM-DD",
                                                        "L"
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Status")]
                                            ),
                                            openInstallment.status ===
                                            "EmAberto"
                                              ? _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "status-badge-open",
                                                  },
                                                  [_vm._v(" Em aberto ")]
                                                )
                                              : _vm._e(),
                                            openInstallment.status ===
                                            "Liquidada"
                                              ? _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "status-badge-paid",
                                                  },
                                                  [_vm._v(" Pago ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _vm.billsInfo && !_vm.loadBoletos && _vm.fromEmitirFatura
        ? _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "container" }, [
                _c("div", { staticClass: "card m-1" }, [
                  _c("div", { staticClass: "card-body" }, [
                    _c("div", { staticClass: "row" }, [
                      _c("div", { staticClass: "col-lg-12 col-12" }, [
                        _c("div", { staticClass: "accordion mb-2" }, [
                          _vm._m(8),
                          _c(
                            "div",
                            {
                              staticClass: "container mt-4",
                              staticStyle: {
                                "background-color": "rgb(245, 245, 245)",
                                "border-radius": "5px",
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "card-header mb-2",
                                  staticStyle: {
                                    "background-color": "#f5f5f5",
                                    "border-radius": "5px",
                                  },
                                  attrs: { id: "head1" },
                                },
                                [
                                  _c("div", { staticClass: "row mt-2" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex col-lg-12 col-12",
                                        staticStyle: {
                                          "justify-content": "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-0",
                                            staticStyle: { color: "black" },
                                          },
                                          [_vm._v("Parcela")]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "text-body mb-0",
                                            staticStyle: {
                                              "font-weight": "bold",
                                              "font-size": "12pt",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  parseInt(
                                                    _vm.currentInstallment
                                                      .installmentNumber
                                                  ) +
                                                    "/" +
                                                    String(
                                                      _vm.billsInfo
                                                        .installmentNumber
                                                    )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex col-lg-12 col-12",
                                        staticStyle: {
                                          "justify-content": "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-0",
                                            staticStyle: { color: "black" },
                                          },
                                          [_vm._v("Valor")]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "text-body mb-0",
                                            staticStyle: {
                                              "font-weight": "bold",
                                              "font-size": "12pt",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatFloatToReal(
                                                    parseFloat(
                                                      _vm.currentInstallment
                                                        .paymentValue,
                                                      10
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex col-lg-12 col-12",
                                        staticStyle: {
                                          "justify-content": "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-0",
                                            staticStyle: { color: "black" },
                                          },
                                          [_vm._v("Vencimento")]
                                        ),
                                        _c(
                                          "p",
                                          {
                                            staticClass: "text-body mb-0",
                                            staticStyle: {
                                              "font-size": "12pt",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatData(
                                                    _vm.currentInstallment
                                                      .dueDate,
                                                    "YYYY-MM-DD",
                                                    "L"
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "d-flex col-lg-12 col-12",
                                        staticStyle: {
                                          "justify-content": "space-between",
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticClass: "mb-0",
                                            staticStyle: { color: "black" },
                                          },
                                          [_vm._v("Status")]
                                        ),
                                        _vm.currentInstallment.status ===
                                        "EmAberto"
                                          ? _c(
                                              "h6",
                                              {
                                                staticClass:
                                                  "status-badge-open",
                                              },
                                              [_vm._v(" Em aberto ")]
                                            )
                                          : _vm._e(),
                                        _vm.currentInstallment.status ===
                                        "Liquidada"
                                          ? _c(
                                              "h6",
                                              {
                                                staticClass:
                                                  "status-badge-paid",
                                              },
                                              [_vm._v(" Pago ")]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ]
                              ),
                              _vm.currentInstallment.pixCopyPaste
                                ? _c("hr", {
                                    staticStyle: {
                                      "border-top": "1px solid #151515",
                                    },
                                  })
                                : _vm._e(),
                              _vm.currentInstallment &&
                              _vm.currentInstallment.pixCopyPaste
                                ? _c("div", { attrs: { id: "divPix" } }, [
                                    _vm._m(9),
                                    _c(
                                      "div",
                                      {
                                        class: [
                                          _vm.largura < 500
                                            ? ""
                                            : "flex-card m-5",
                                        ],
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            class: [
                                              _vm.largura < 500
                                                ? "col-xs-8 col-12 d-flex flex-column col-lg-5 pb-3 pt-2 flex-align-center"
                                                : "",
                                            ],
                                          },
                                          [
                                            _c("qrcode-vue", {
                                              staticStyle: {
                                                "background-color": "#fff",
                                                padding: "10px",
                                              },
                                              attrs: {
                                                value:
                                                  _vm.currentInstallment
                                                    .pixCopyPaste,
                                                size: 150,
                                                level: "H",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("div", { staticClass: "my-auto" }, [
                                          _vm.largura > 500
                                            ? _c(
                                                "p",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    " Acesse seu App de pagamentos e faça a leitura do QR Code ao lado para efetuar o pagamento de forma segura e rápida. "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.largura < 500
                                            ? _c(
                                                "p",
                                                { staticClass: "text-center" },
                                                [
                                                  _vm._v(
                                                    " Acesse seu App de pagamentos e faça a leitura do QR Code acima para efetuar o pagamento de forma segura e rápida. "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          color: "red",
                                          "font-size": "12px",
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " ATENÇÃO! Evite fraudes: Antes de efetuar o PIX para pagamento do seu acordo PORTOBANK, verifique o NOME do beneficiário e CNPJ. "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "mt-3",
                                        staticStyle: { "font-size": "12px" },
                                      },
                                      [
                                        _vm._v(
                                          " Lembrando que os pagamentos realizados via PIX são baixados até 2 horas. Caso pague via boleto o prazo de baixa é de 2 dias úteis. "
                                        ),
                                      ]
                                    ),
                                    _vm._m(10),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "col-xs-8 col-12 col-lg-12 px-1 mt-2",
                                        staticStyle: {
                                          "background-color": "#d9d9d9",
                                          "border-radius": "5px",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "d-flex",
                                            staticStyle: {
                                              "align-items": "center",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.copiarCodigoPix(
                                                  _vm.currentInstallment
                                                    .pixCopyPaste
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass:
                                                  "codebar text-start",
                                                staticStyle: {
                                                  "background-color": "#d9d9d9",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.currentInstallment
                                                        .pixCopyPaste
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                            _c("i", {
                                              staticClass: "fa fa-clone mr-2",
                                              attrs: { "aria-hidden": "true" },
                                            }),
                                          ]
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "text-center",
                                        on: {
                                          click: function ($event) {
                                            return _vm.copiarCodigoPix(
                                              _vm.currentInstallment
                                                .pixCopyPaste
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              color: "black",
                                              cursor: "pointer",
                                            },
                                          },
                                          [_vm._v("Clique para copiar")]
                                        ),
                                      ]
                                    ),
                                    !_vm.boletoGerado
                                      ? _c("div", [
                                          !_vm.loadingBoleto
                                            ? _c(
                                                "button",
                                                {
                                                  staticClass:
                                                    "btn-primary mr-2 mb-4 p-2",
                                                  staticStyle: {
                                                    width: "100%",
                                                    "border-radius": "20px",
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.getBillInfo()
                                                    },
                                                  },
                                                },
                                                [_vm._v(" GERAR BOLETO ")]
                                              )
                                            : _vm._e(),
                                        ])
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                              _vm.loadingBoleto &&
                              _vm.contentInstallment === _vm.currentInstallment
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "col-xs-8 col-12 d-flex flex-column col-lg-12 pb-3 pt-2",
                                    },
                                    [
                                      _c("ProgressLoading", {
                                        attrs: { loading: _vm.loadingBoleto },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm.contentInstallment.digitableLine
                                ? _c(
                                    "div",
                                    {
                                      class: [
                                        _vm.contentInstallment.digitableLine
                                          ? "collapse show mt-3"
                                          : "collapse",
                                      ],
                                      attrs: { "aria-labelledby": "heading1" },
                                    },
                                    [
                                      _c(
                                        "h6",
                                        {
                                          staticClass:
                                            "border-bottom pb-3 mb-0 ml-2",
                                        },
                                        [_vm._v(" Boleto ")]
                                      ),
                                      _c(
                                        "div",
                                        { staticClass: "card-body px-4" },
                                        [
                                          _vm.contentInstallment
                                            .digitableLine ||
                                          _vm.contentInstallment.status !==
                                            "Liquidada"
                                            ? _c(
                                                "div",
                                                { staticClass: "row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-xs-8 col-12 col-lg-12 px-1",
                                                    },
                                                    [
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "text-info mb-1",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "Linha digitável:"
                                                          ),
                                                        ]
                                                      ),
                                                      _vm.contentInstallment
                                                        .digitableLine
                                                        ? _c(
                                                            "a",
                                                            {
                                                              staticClass:
                                                                "text-primary btn-link btn-sm float-right mt-2 pl-1 pr-3",
                                                              staticStyle: {
                                                                cursor:
                                                                  "pointer",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.copiarLinhaDigitavel(
                                                                      _vm
                                                                        .contentInstallment
                                                                        .digitableLine
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("Copiar")]
                                                          )
                                                        : _vm._e(),
                                                      _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "codebar",
                                                          staticStyle: {
                                                            "background-color":
                                                              "rgb(217, 217, 217)",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm
                                                                  .contentInstallment
                                                                  .digitableLine
                                                              ) +
                                                              " "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "col-12 d-flex col-lg-12 flex-row px-0 mt-2 justify-content-around",
                                                    },
                                                    [
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "text-primary btn-link mr-1 mb-1 text-left",
                                                          attrs: {
                                                            disabled:
                                                              _vm.loadingDownloadEmitirFatura ||
                                                              _vm.loading,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.downloadBoleto(
                                                                _vm.contentInstallment
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-download fa-fw pull-left pt-1 pb-2 d-none d-sm-block",
                                                          }),
                                                          _vm._v(
                                                            " Baixar boleto "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "text-primary mr-1 mb-1 btn-link text-left",
                                                          attrs: {
                                                            disabled:
                                                              _vm.loadingDownloadEmitirFatura ||
                                                              _vm.loading ||
                                                              (!_vm.user
                                                                .PhoneNumber &&
                                                                !_vm.user
                                                                  .MobileNumber),
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.sendSms(
                                                                _vm
                                                                  .contentInstallment
                                                                  .digitableLine
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-mobile fa-fw fa-lg pull-left mr-1 pt-1 pb-2 d-none d-sm-block",
                                                          }),
                                                          _vm._v(
                                                            "Receber por SMS "
                                                          ),
                                                        ]
                                                      ),
                                                      _c(
                                                        "button",
                                                        {
                                                          staticClass:
                                                            "text-primary mr-1 mb-1 btn-link text-left",
                                                          attrs: {
                                                            disabled:
                                                              _vm.loadingDownloadEmitirFatura ||
                                                              _vm.loading ||
                                                              !_vm.user.Email,
                                                          },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.sendEmail(
                                                                _vm
                                                                  .contentInstallment
                                                                  .digitableLine
                                                              )
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c("i", {
                                                            staticClass:
                                                              "fa fa-envelope-o fa-fw pull-left pt-1 pb-2 d-none d-sm-block",
                                                          }),
                                                          _vm._v(
                                                            "Receber por e-mail "
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _vm.loading
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-xs-8 col-12 d-flex flex-column col-lg-12 pb-3 pt-2",
                                                        },
                                                        [
                                                          _c(
                                                            "ProgressLoading",
                                                            {
                                                              attrs: {
                                                                loading:
                                                                  _vm.loading,
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm.loadingDownloadEmitirFatura
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-xs-8 col-12 d-flex flex-column col-lg-12 pb-3 pt-2",
                                                        },
                                                        [
                                                          _c(
                                                            "ProgressLoading",
                                                            {
                                                              attrs: {
                                                                loading:
                                                                  _vm.loadingDownloadEmitirFatura,
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ]
                                              )
                                            : _vm._e(),
                                        ]
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          ),
                        ]),
                        _c("hr"),
                        !_vm.loading && _vm.openInstallments.length > 0
                          ? _c(
                              "div",
                              {
                                staticClass: "d-flex",
                                staticStyle: {
                                  "justify-content": "space-between",
                                  "align-items": "baseline",
                                },
                              },
                              [
                                _c("h5", { staticClass: "text-bold mt-2" }, [
                                  _vm._v("Mais parcelas em aberto"),
                                ]),
                                _c(
                                  "a",
                                  {
                                    staticClass: "nav-link dropdown-toggle",
                                    attrs: {
                                      href: "#openParcels",
                                      id: "userDropdownOpen",
                                      role: "button",
                                      "aria-haspopup": "true",
                                      "aria-expanded": "dropdownOpen",
                                    },
                                    on: {
                                      click: _vm.toggleDropdownOpenInstallments,
                                    },
                                  },
                                  [
                                    !_vm.dropdownOpenInstallments
                                      ? _c("i", {
                                          staticClass: "fa fa-angle-down fa-lg",
                                        })
                                      : _vm._e(),
                                    _vm.dropdownOpenInstallments
                                      ? _c("i", {
                                          staticClass: "fa fa-angle-up fa-lg",
                                        })
                                      : _vm._e(),
                                  ]
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: _vm.dropdownOpenInstallments,
                                expression: "dropdownOpenInstallments",
                              },
                            ],
                            staticClass: "accordion",
                          },
                          _vm._l(
                            _vm.openInstallments,
                            function (openInstallment, key1, index1) {
                              return _c(
                                "div",
                                {
                                  key: `${key1}-${index1}`,
                                  staticClass: "card m-0 px-0 py-0 mb-2",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "card-header",
                                      staticStyle: {
                                        "background-color": "#f5f5f5",
                                        "border-radius": "5px",
                                      },
                                      attrs: { id: "head3" },
                                    },
                                    [
                                      _c("div", { staticClass: "row p-3" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Parcela")]
                                            ),
                                            _vm.isEmitirFatura
                                              ? _c(
                                                  "h6",
                                                  { staticClass: "text-body" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          key1 +
                                                            1 +
                                                            "/" +
                                                            (key1 + 1)
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.isFromProposals
                                              ? _c(
                                                  "h6",
                                                  { staticClass: "text-body" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          openInstallment.installmentNumber +
                                                            "/" +
                                                            String(
                                                              _vm.billsInfo
                                                                .installmentNumber
                                                            )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm.isFromAgreements
                                              ? _c(
                                                  "h6",
                                                  { staticClass: "text-body" },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          parseInt(
                                                            openInstallment.installmentNumber
                                                          ) +
                                                            1 +
                                                            "/" +
                                                            String(
                                                              _vm.agreementInfo
                                                                .installmentNumber
                                                            )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Valor")]
                                            ),
                                            _c(
                                              "h6",
                                              { staticClass: "text-body" },
                                              [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.formatFloatToReal(
                                                        parseFloat(
                                                          openInstallment.paymentValue,
                                                          10
                                                        )
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Vencimento")]
                                            ),
                                            _c("h6", {}, [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.formatData(
                                                      openInstallment.dueDate,
                                                      "YYYY-MM-DD",
                                                      "L"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex col-lg-12 col-12",
                                            staticStyle: {
                                              "justify-content":
                                                "space-between",
                                            },
                                          },
                                          [
                                            _c(
                                              "p",
                                              {
                                                staticClass: "mb-1",
                                                staticStyle: { color: "black" },
                                              },
                                              [_vm._v("Status")]
                                            ),
                                            openInstallment.status ===
                                            "EmAberto"
                                              ? _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "status-badge-open",
                                                  },
                                                  [_vm._v(" Em aberto ")]
                                                )
                                              : _vm._e(),
                                            openInstallment.status ===
                                            "Liquidada"
                                              ? _c(
                                                  "h6",
                                                  {
                                                    staticClass:
                                                      "status-badge-paid",
                                                  },
                                                  [_vm._v(" Pago ")]
                                                )
                                              : _vm._e(),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            }
                          ),
                          0
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ])
        : _vm._e(),
      _c(
        "modal",
        {
          staticStyle: { margin: "auto" },
          attrs: { name: "newEmail", height: "auto" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h5",
                { staticClass: "modal-title", attrs: { id: "eModalLabel" } },
                [_vm._v(" Você não tem nenhum e-mail cadastrado. ")]
              ),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.fecharModal()
                    },
                  },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("x"),
                  ]),
                ]
              ),
            ]),
            _c("label", { staticClass: "m-4" }, [
              _vm._v("Por favor, informe um novo e-mail."),
            ]),
            _c("div", { staticClass: "col-12" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newEmail,
                    expression: "newEmail",
                  },
                ],
                staticClass: "form-control my-3",
                attrs: {
                  disabled: _vm.loading,
                  maxlength: "50",
                  type: "text",
                  placeholder: "E-mail",
                },
                domProps: { value: _vm.newEmail },
                on: {
                  change: function ($event) {
                    return _vm.eventFillInputEmailGTM()
                  },
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.newEmail = $event.target.value
                  },
                },
              }),
            ]),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                !_vm.loading
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary text-white",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: {
                          click: function ($event) {
                            return _vm.fecharModal("cancelar")
                          },
                        },
                      },
                      [_vm._v(" Cancelar ")]
                    )
                  : _vm._e(),
                !_vm.loading
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            return _vm.insertNewEmailAndSend()
                          },
                        },
                      },
                      [_vm._v("Cadastrar")]
                    )
                  : _vm._e(),
                _c("ProgressLoading", { attrs: { loading: _vm.loading } }),
              ],
              1
            ),
          ]),
        ]
      ),
      _c(
        "modal",
        {
          staticStyle: { margin: "auto" },
          attrs: { name: "newPhoneNumber", height: "auto" },
        },
        [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h5",
                { staticClass: "modal-title", attrs: { id: "eModalLabel" } },
                [_vm._v(" Você não tem nenhum telefone cadastrado. ")]
              ),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-dismiss": "modal",
                    "aria-label": "Close",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.fecharModalNewPhone()
                    },
                  },
                },
                [
                  _c("span", { attrs: { "aria-hidden": "true" } }, [
                    _vm._v("x"),
                  ]),
                ]
              ),
            ]),
            _c("label", { staticClass: "m-4" }, [
              _vm._v("Por favor, informe um novo número de telefone."),
            ]),
            _c("div", { staticClass: "col-12" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.newPhoneNumber,
                    expression: "newPhoneNumber",
                  },
                  {
                    name: "mask",
                    rawName: "v-mask",
                    value: ["(##) # ####-####"],
                    expression: "['(##) # ####-####']",
                  },
                ],
                staticClass:
                  "form-control form-control-lg text-center home-form quicks mb-2",
                attrs: {
                  type: "tel",
                  placeholder: "Informe o telefone aqui",
                  id: "form10",
                },
                domProps: { value: _vm.newPhoneNumber },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.newPhoneNumber = $event.target.value
                  },
                },
              }),
            ]),
            _c(
              "div",
              { staticClass: "modal-footer" },
              [
                !_vm.loading
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-secondary text-white",
                        attrs: { type: "button", "data-dismiss": "modal" },
                        on: {
                          click: function ($event) {
                            return _vm.fecharModalNewPhone()
                          },
                        },
                      },
                      [_vm._v(" Cancelar ")]
                    )
                  : _vm._e(),
                !_vm.loading
                  ? _c(
                      "a",
                      {
                        staticClass: "btn btn-primary",
                        attrs: { href: "#" },
                        on: {
                          click: function ($event) {
                            return _vm.insertNewPhoneNumberAndSend()
                          },
                        },
                      },
                      [_vm._v("Cadastrar")]
                    )
                  : _vm._e(),
                _c("ProgressLoading", { attrs: { loading: _vm.loading } }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 mb-1 pl-1" }, [
      _c("h5", { staticClass: "d-flex align-items-center" }, [
        _vm._v(" Parcelas do acordo "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "my-auto" }, [
      _c("p", { staticClass: "text-info text-center mx-4" }, [
        _vm._v(
          " Acesse seu App de pagamentos e faça a leitura do QR Code ao lado para efetuar o pagamento de forma segura e rápida. "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 text-center" }, [
      _c("h5", { staticClass: "text-bold" }, [_vm._v("Parcela em aberto")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 text-center" }, [
      _c("h5", { staticClass: "text-bold" }, [_vm._v("PIX")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mt-3" }, [
      _c("p", { staticClass: "mb-0" }, [_vm._v("Código de pagamento PIX:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 text-center" }, [
      _c("h5", { staticClass: "text-bold" }, [_vm._v("Parcela em aberto")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 text-center" }, [
      _c("h5", { staticClass: "text-bold" }, [_vm._v("PIX")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mt-3" }, [
      _c("p", { staticClass: "mb-0" }, [_vm._v("Código de pagamento PIX:")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 text-center" }, [
      _c("h5", { staticClass: "text-bold" }, [_vm._v("Parcela em aberto")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "col-12 text-center" }, [
      _c("h5", { staticClass: "text-bold" }, [_vm._v("PIX")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mt-3" }, [
      _c("p", { staticClass: "mb-0" }, [_vm._v("Código de pagamento PIX:")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }